module.exports = __webpack_public_path__ + "img/charm_5.2212dd38.svg";